import { createApp, defineAsyncComponent } from 'vue';
import iziToast from '../plugins/izitoast';
import helper from '../utils/helper';

const app = createApp({
    components: {
        VuePublications: defineAsyncComponent(() => import('./Publications.vue')),
    },
});

app.use(iziToast);
app.mixin(helper);
app.mount('#vue__publications');